if(window.innerWidth > 960) {
    document.addEventListener("DOMContentLoaded", function() {
        var previousScrollTop = 0;
    
        var header = document.querySelector('.header');
        var navMain = document.querySelector('#js-NavMain');
    
        header.addEventListener('animationend', function(event) {
            if (event.animationName === 'slideUp') {
                header.classList.remove('header--fixed');
            }
        });
    
        window.addEventListener('scroll', function() {
            var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (currentScrollTop < previousScrollTop) {
                // Scrolling vers le haut
                if (currentScrollTop > 350) {
                    header.classList.add('header--fixed');
                    header.classList.remove('slide-up');
                } else if (!header.classList.contains('slide-up')) { 
                    header.classList.add('slide-up');
                }
            } else {
                // Scrolling vers le bas
                if (!header.classList.contains('slide-up') && currentScrollTop > 350) { 
                    header.classList.add('slide-up');
                }
    
                // Si on scroll vers le bas le menu se ferme
                if (currentScrollTop > 0) {
                    navMain.classList.remove('js-active-menu');
                }
            }
    
            // Supprimer les classes en haut de la page pour que le header reprenne sa forme initiale
            if (currentScrollTop <= 350) {
                header.classList.remove('slide-up');
                header.classList.remove('header--fixed');
            }
    
            previousScrollTop = currentScrollTop;
        });
    });
}
